import { Storage } from "aws-amplify";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

const MediaImage = ({ media, ...props }) => {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (media.mediaId) {
      (async () => {
        try {
          setUrl(await Storage.get(media.mediaId));
        } catch (error) {
          // Do nothing
        }
      })();
    }
  }, [media.mediaId]);
  return url ? <img {...props} src={url} /> : <div {...props} />;
};

MediaImage.propTypes = {
  media: PropTypes.shape({
    mediaId: PropTypes.string,
  }).isRequired,
};

export default MediaImage;
